import type { GridColDef } from "@mui/x-data-grid-premium";
import React, { useContext, useEffect, useState } from "react";
import { PatientContext } from "../../../contexts/PatientContext.tsx";
import { ProjectContext } from "../../../contexts/ProjectContext";
import { useFetch } from "../../../services/hooks/useFetch";
import { projectsPrefix } from "../../../services/ProjectsServices";
import AccordionTable from "../../datagrid/AccordionTable.tsx";

export default function ProblemsDataExpandTable() {
  const { id: projectId } = useContext(ProjectContext) || {};
  const { id, problemsCount } = useContext(PatientContext) || {};

  const {
    data: problemData,
    error: problemsError,
    fetch: fetchProblems,
    isLoading: problemsLoading,
  } = useFetch<Problem[]>();

  const [shouldFetchProblems, setShouldFetchProblems] = useState(false);

  const problemDataFields: GridColDef<Problem>[] = [
    {
      field: "problemName",
      headerName: "Problem",
      width: 250,
      type: "string",
    },
    {
      field: "yearNoted",
      headerName: "Year Noted",
      width: 100,
      type: "number",
      valueFormatter: (value: number) => value.toString(),
    },
    {
      field: "diffDays",
      headerName: "Pre/Post Index",
      width: 115,
      type: "number",
    },
    {
      field: "patientAgeAtEvent",
      headerName: "Age",
      width: 100,
      type: "number",
    },
    {
      field: "problemStatus",
      headerName: "Status",
      width: 100,
      type: "singleSelect",
      valueOptions: ["ACTIVE", "INACTIVE", "CANCELED", "RESOLVED"],
    },
  ];

  useEffect(() => {
    if (shouldFetchProblems && !problemsLoading && !problemsError) {
      void fetchProblems(
        `${projectsPrefix}/${projectId}/patients/${id}/problems`,
        {
          postResponseAction: () => {
            setShouldFetchProblems(false);
          },
        },
      );
    }
  }, [
    fetchProblems,
    id,
    problemsError,
    problemsLoading,
    projectId,
    shouldFetchProblems,
  ]);

  return (
    <AccordionTable
      title={"Problems"}
      highlightField={"createdAt"}
      highlightCount={problemsCount?.highlight}
      totalCount={problemsCount?.total || 0}
      tableHeight={400}
      triggerFetch={() => setShouldFetchProblems(true)}
      loading={shouldFetchProblems}
      columns={problemDataFields}
      rows={problemData || []}
      disableRowGrouping
      tableId="problems-data-expand-table"
    />
  );
}
